<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <!-- TODO 1: Loading State Handler -->
      <div v-if="isLoading"><LoadingData /></div>

      <!--  TODO 2: Data Handler -->
      <div v-else>
        <div>
          <div>
            <div>
              <b>Low Balance Notification</b>
              <md-field>
                <label>Amount</label>
                <md-input
                v-model="lowBalanceThreshold.amount"
                  type="number"
                ></md-input>
              </md-field>
              <md-field>
                <label>Percentage (Seperate percentage number with commas. e.g 100, 50, 0)</label>
                <md-input
                v-model="lowBalanceThreshold.percentage"
                  type="text"
                  placeholder="100,50,30"
                ></md-input>
              </md-field>
            </div>
          </div>
          <md-button class="md-primary"
          :disabled="!lowBalanceThreshold.amount || !lowBalanceThreshold.percentage"
          @click="setNotification()"
            >Set Threshold Balance</md-button
          >
        </div>
      </div>
    </div>
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
// import axios from "axios";
import http from '../../../utils/Http.util';
import LoadingData from '../../../components/LoadingData.vue';
// import SwitchEnvironment from './SwitchEnvironment.vue';

export default {
  components: {
    LoadingData,
    // SwitchEnvironment,
  },
  created() {
    this.fetchNotification();
  },
  computed: {},

  data() {
    return {
      configuration: {},
      path: {
        amount: 'notification:wallet:lowBalanceThreshold:amount',
        percentage: 'notification:wallet:lowBalanceThreshold:percentage',
      },
      lowBalanceThreshold: {
        amount: 0,
        percentage: 0,
      },
      isLoading: false,
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    async fetchNotification() {
      this.isLoading = true;
      try {
        const [amountResponse, percentageResponse] = await Promise.all([
          await http.authReq(
            `/dashboard/business/configurations/${this.path.amount}`,
          ),
          await http.authReq(
            `/dashboard/business/configurations/${this.path.percentage}`,
          ),
        ]);
        // [this.configuration] = data;
        this.lowBalanceThreshold.amount = amountResponse.data.length && amountResponse.data[0].value;
        this.lowBalanceThreshold.percentage = percentageResponse.data.length && percentageResponse.data[0].value;
        this.snackBar = {
          show: true,
          message: 'Fetch Successful',
        };
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
      } finally {
        this.isLoading = false;
      }
    },

    async setNotification() {
      this.isLoading = true;
      this.$store.commit('busyStatus', true);
      try {
        // Validate Percentatage

        let percentages = this.lowBalanceThreshold.percentage.split(',').map((p) => p.trim());

        percentages.forEach((p) => {
          if (Number.isNaN(p)) throw new Error(`${p} is an invalid percentage number`);
          if (Number(p) > 100 || Number(p) < 0) throw new Error(`${p} needs be between 0 - 100`);
        });

        const hasDuplicates = (arr) => new Set(arr).size !== arr.length;
        if (hasDuplicates(percentages)) throw new Error('Percentages must be unique');

        percentages = percentages.sort((a, b) => parseFloat(b) - parseFloat(a));

        percentages = percentages.join(',');

        const body = [{
          path: this.path.amount,
          value: Number(this.lowBalanceThreshold.amount),
        },
        {
          path: this.path.percentage,
          value: percentages,
        },
        ];
        await http.authReq(
          '/dashboard/business/configurations',
          body,
          'patch',
        );
        this.fetchNotification();
        this.snackBar = {
          show: true,
          message: 'Settings have been updated successfully',
        };
        this.isLoading = false;
        this.$store.commit('busyStatus', false);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        this.isLoading = false;
        this.$store.commit('busyStatus', false);
      }
    },
  },
};
</script>
